import { GameData } from "../gamestate/gameData";
import {
  updateWin,
  resetExtraSpin,
  replaceAllWithBonus,
  toggleBonusGameMode,
  GetWinlineCombo,
  checkSymbolToExpand,
  betSuccessCallBack,
  disableAllBtns,
  resetAllBtns,
  clearOnReplayOpenClose,
  // expandSymbolRequest,
} from "../inGameFunction";
import { GameColumn } from "./GameColumn";
import { GameTile } from "./GameTile";
import { WinLineBuilder } from "./WinLineBuilder";
import {
  gambleClick,
  checkUserBalToBet,
} from "../../../common/functions/Functions_GameBar";
import { GameElement } from "../../../common/gameLib/BaseGame/GameElement";
import {
  getAllIndexes,
  isNullOrUndefined,
  setAllowedInputs,
  updateWinBar,
} from "../../../common/functions/Functions_General";

import { convertCreditsFromServerToClient } from "../../../common/datastructures/Credits";
import { ExpandAnimation } from "./BonusGame_BookOf/bonusSymbolExpand";
import { extraSpinsWinBonusGameAdd } from "../../../common/gameLib/bonusExtraSpinWIn/bonusExtraSpinsWinMessage";
import { SuspenseFramesBuilder } from "../../../common/gameLib/Effects/suspenseEffects";
import { BonusSymbolHighlighter } from "../../../common/gameLib/Effects/highlightBonusSymbols";
import { PostExpandAnimationPillar } from "./BonusGame_BookOf/postExpandAnimation";
import { ExpandingSymbolHighlight } from "./BonusGame_BookOf/highLightExpandingTile";
import { BonusLabelChristmasJoyUI } from "../../../common/gameLib/CountersWithLabels/bonusLabelChristmasJoyUIBuilder";
import { BonusSymbolPickerBookAnimation } from "./BonusGame_BookOf/symbolSelector/bonusSymbolPickAnimation";
import { HoldPressedCircularBtn } from "../../../common/gameLib/buttonsLibrary";
import { BonusSymbolPickedOverlay } from "./BonusGame_BookOf/symbolSelector/SelectedBonusSymbolOverlay";
import { TalesOfTimeGameContext } from "../datastructures/bookOfX_Interface";
import {
  enableEmulationInterfaceOnFeatureSelect,
  updateEmulationWinBalance,
} from "../../../common/gameLib/Replay/emulation/functionsEmulations";
// import { extraSpinsWinBookOfSomething } from "./extraSpinWinAnimation";

export class SpinGame extends GameElement<GameData> {
  private totalRow: number;
  private totalCol: number;
  private gameTilesContainer: PIXI.Container;
  private decoContainer: PIXI.Container;
  private deltaTime: number;
  private dicelines: Array<Array<GameTile>>;
  private cardSizeX: number;
  private cardSizeY: number;
  private gameBoardMask: PIXI.Graphics;
  // private currentWin: Array<number>;
  private winlineToDisplay: any;
  private parentContainerWrapper: PIXI.Graphics;
  private reel: Array<Array<number>>;
  private extraSpinFXContainer: PIXI.Container;
  private dragonHighlighterContainer: PIXI.Container;
  private lastReelTween: PIXI.tween.Tween;

  private parentContainer: PIXI.Container;
  private gameStartTicker: PIXI.ticker.Ticker;
  private columns: Array<GameColumn>;
  private winlines: WinLineBuilder; //??

  private gameReelsBGPortraitMode: PIXI.Sprite;
  // private displayBonusCountParent: PIXI.Container = new PIXI.Container();
  // private bonusCountTextDisplay: PIXI.Text;
  // private bonusTotalWin: PIXI.Text;
  private bonusSpinsLeft: number;
  private bonusUsed: boolean;
  private bonusGameOverlay: PIXI.Sprite;
  private bonusGameRandomSymbolPicker: BonusSymbolPickerBookAnimation;

  private expandedWinlinesActive: boolean;

  private expandAllowed: boolean;

  private bonusGameExpandAnimation: ExpandAnimation;

  private extraBonusSpins: extraSpinsWinBonusGameAdd;
  private suspenseAnimation: SuspenseFramesBuilder;
  private highlightBonusSymbol: BonusSymbolHighlighter;
  private expandingSymbolHighlight: ExpandingSymbolHighlight;
  private postExpandAnim: PostExpandAnimationPillar;

  private display_totalWin: BonusLabelChristmasJoyUI;
  private display_spinsLeft: BonusLabelChristmasJoyUI;
  private isExpandBonusActive: boolean = false;
  private holdToSkipExpandBtn: HoldPressedCircularBtn;
  private bonusSymbolSelectedDisplay: BonusSymbolPickedOverlay;
  constructor(activeGameData: GameData, parent: PIXI.Container) {
    super(activeGameData, parent);
    this.setExpandedWinlinesActive(false);
    this.expandAllowed = false;
    this.bonusUsed = false;
    this.bonusSpinsLeft = 0;
    this.activeGameData.cardsize = 270;
    // this.activeGameData.cardsize = 265;
    this.totalRow = 3;
    this.totalCol = 5;
    // this.parentfadeOutTween;
    this.parentContainer = new PIXI.Container();
    this.gameTilesContainer = new PIXI.Container();
    this.decoContainer = new PIXI.Container();
    this.deltaTime;
    this.gameStartTicker = new PIXI.ticker.Ticker();
    this.dicelines = []; //contain the list of  dices for each winlines
    this.columns = [];
    this.cardSizeX;
    this.cardSizeY;
    this.gameBoardMask;
    this.winlines;
    this.winlineToDisplay;
    // this.currentWin;
    this.parentContainerWrapper = new PIXI.Graphics();
    this.reel = [];
    this.extraSpinFXContainer = new PIXI.Container();
    this.dragonHighlighterContainer = new PIXI.Container();

    if (this.activeGameData.reloadGame == true) {
      this.parentContainer.alpha = 0;
    }
    this.createGameReelBG();
    this.create();
    this.setgameTicker();

    this.placeTo(this.parent);

    //--create wild game

    this.display_totalWin = new BonusLabelChristmasJoyUI(
      this.parent,
      activeGameData.gameTextStyle.gameFont,
      activeGameData.gameText.totalWin,
      activeGameData.currency,
      true
    );
    this.display_spinsLeft = new BonusLabelChristmasJoyUI(
      this.parent,
      activeGameData.gameTextStyle.gameFont,
      activeGameData.gameText.firespinsleft,
      activeGameData.currency,
      false
    );
    this.display_spinsLeft.setPosition(
      activeGameData.size[0] / 2 + 340,
      activeGameData.size[1] - 150
    );

    this.display_totalWin.setPosition(
      activeGameData.size[0] / 2 - 340,
      activeGameData.size[1] - 150
    );
    this.display_totalWin.setValue("0.00");
    this.display_spinsLeft.setValue(0);

    this.extraBonusSpins = new extraSpinsWinBonusGameAdd(
      this.activeGameData,
      this.display_spinsLeft.getParent()
    );

    ///-extra customization
    this.display_totalWin.createFrame("label_center", "label_corner");
    this.display_spinsLeft.createFrame("label_center", "label_corner");

    //--align
    // this.display_totalWin.alignLeft();
    // this.display_spinsLeft.alignRight();

    this.display_totalWin.setFixedWith(650);
    this.display_spinsLeft.setFixedWith(650);
    //-create overlay
    this.display_totalWin.createAnimatedOverlay("bonusLabelBG", 0, 20);
    this.display_spinsLeft.createAnimatedOverlay("bonusLabelBG", 0, 20);

    //-define the function to launch when the extraspin animations ends

    this.extraBonusSpins.setOnCloseCallBackFunction(
      this.checkExpandOnExtraSpinWinButNoWinlines
    );

    this.setBonusLeftVisible(false);

    this.bonusGameOverlay = new PIXI.Sprite(
      PIXI.Texture.fromFrame("bg_PastEgyptCenter.png")
    );

    // let overlayChildtext = new PIXI.Sprite(
    //   PIXI.Texture.fromFrame("sergioOverlay2.png")
    // );
    // this.bonusGameOverlay.addChild(overlayChildtext);
    this.bonusGameOverlay.anchor.set(0.5);
    this.bonusGameOverlay.x = activeGameData.size[0] / 2;
    this.bonusGameOverlay.y = activeGameData.size[1] / 2;

    // overlayChildtext.anchor.set(0.5);
    // // overlayChildtext.x = activeGameData.size[0] / 2;
    // overlayChildtext.y = 200;

    this.parent.addChild(this.bonusGameOverlay);

    this.setbonusGameOverlayVisible(false);
    // this.activeGameData.sergioWinAnimation= new SergioWinAnimation(this.activeGameData.messageContainer,this.activeGameData.size)

    //--
    this.bonusGameRandomSymbolPicker = new BonusSymbolPickerBookAnimation(
      this.activeGameData.messageContainerNoClipping,
      activeGameData
    );

    //--test
    // this.changeSymbolTimeToPresent(false);
    // this.initialRandom();

    //-overlayanimation on suspense
    this.suspenseAnimation = new SuspenseFramesBuilder(
      this.gameTilesContainer,
      5,
      [133, 1920 / 2],
      267
    );
    this.highlightBonusSymbol = new BonusSymbolHighlighter(
      this.gameTilesContainer,
      5,
      [133, 1920 / 2 - 280],
      267,
      267
    );

    this.expandingSymbolHighlight = new ExpandingSymbolHighlight(
      this.parentContainer,
      5,
      [133, 1080 / 2 - 80],
      267,
      267
    );

    this.postExpandAnim = new PostExpandAnimationPillar(
      this.gameTilesContainer,
      6,
      [0, 1920 / 2],
      267
    );

    this.postExpandAnim.clearAll();

    this.bonusSymbolSelectedDisplay = new BonusSymbolPickedOverlay(
      this.activeGameData.gameSceneBonus,
      this.activeGameData
    );
  }
  public getBonusSymbolPickedOverlay = (): BonusSymbolPickedOverlay => {
    return this.bonusSymbolSelectedDisplay;
  };

  public setIsExpandBonusActive = (bool: boolean) => {
    this.isExpandBonusActive = bool;
  };
  public getIsExpandBonusActive = (): boolean => {
    return this.isExpandBonusActive;
  };
  public getBonusSymbolPickerBookAnimation = (): BonusSymbolPickerBookAnimation => {
    return this.bonusGameRandomSymbolPicker;
  };
  public getPostExpandAnim = (): PostExpandAnimationPillar => {
    return this.postExpandAnim;
  };
  public gethighlightBonusSymbol = (): BonusSymbolHighlighter => {
    return this.highlightBonusSymbol;
  };

  public getExpandingHighlightTile = (): ExpandingSymbolHighlight => {
    return this.expandingSymbolHighlight;
  };

  public checkSymbolTime = (): void => {
    let isPresent = true;

    if (this.activeGameData.GameContext().bonusGameResult != undefined) {
      isPresent = false;
    }

    // console.log(
    //   "IS PRESENT : ",
    //   isPresent,
    //   this.activeGameData.GameContext().bonusGameResult
    // );

    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].swapSymbolPresent(isPresent);
    }
  };

  public clearBonusSymbolsBackground = (): void => {
    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].clearBonusBackgroundSymbol();
    }

    this.bonusGameExpandAnimation.clear();
  };

  public getExpandAnimation = (): ExpandAnimation => {
    return this.bonusGameExpandAnimation;
  };

  public checkForRandomSymbol = (bool: boolean): void => {
    if (bool) {
      ///-at the beginning of the bonus game pic the random  bonus symbol
      if (
        this.activeGameData.GameContext().usedInputAction ==
        this.activeGameData.API_handler.getServerActionBet()
      ) {
        let symbolResult = this.activeGameData.GameContext().expandingSymbol;
        this.bonusGameRandomSymbolPicker.startNewBonusAnimation(symbolResult);
      }
    } else {
      if (this.bonusGameRandomSymbolPicker.isVisible() == true) {
        this.bonusGameRandomSymbolPicker.close();
      }
    }
  };

  public forceCloseBonusSymbolSelectionScreen = (): void => {
    if (this.bonusGameRandomSymbolPicker.isVisible() == true) {
      this.bonusGameRandomSymbolPicker.forceClose();
    }
  };
  public setbonusGameOverlayVisible = (booL: boolean): void => {
    // if(this.activeGameData.replayMode==false)
    // {
    //   this.bonusGameOverlay.alpha = booL ? 1 : 0;
    // }
    // else
    // {
    //   this.bonusGameOverlay.alpha =0;
    // }

    this.bonusGameOverlay.alpha = booL ? 1 : 0;
  };
  private createGameReelBG = (): void => {
    this.gameReelsBGPortraitMode = new PIXI.Sprite(
      PIXI.Texture.fromFrame("gameReelPortrait.png")
    );
    this.activeGameData.gameScene.addChild(this.gameReelsBGPortraitMode);
    this.gameReelsBGPortraitMode.height = 845;
    this.gameReelsBGPortraitMode.width =
      this.gameReelsBGPortraitMode.width * 1.03;
    this.gameReelsBGPortraitMode.y = 98;
    this.gameReelsBGPortraitMode.x =
      this.activeGameData.size[0] / 2 - this.gameReelsBGPortraitMode.width / 2;
    this.gameReelsBGPortraitMode.alpha = 0;
    window.addEventListener("resize", this.setPortraitReelVisible, false);
    this.setPortraitReelVisible();

    let lines = [];
    for (let i = 0; i < 4; i++) {
      lines[i] = new PIXI.Sprite(PIXI.Texture.fromImage("separateLine.png"));
      lines[i].anchor.set(0.5);
      lines[i].scale.x = 0.5;
      lines[i].scale.y = 1;
      lines[i].x = this.gameReelsBGPortraitMode.width / 2 - 406 + i * 258.2;
      lines[i].y = 405;
      lines[i].blendMode = PIXI.BLEND_MODES.SCREEN;
      this.gameReelsBGPortraitMode.addChild(lines[i]);
    }
  };

  public setColumnVisibilty = (cIndex: number, bool: boolean): void => {
    let newAlpha = bool ? 1 : 0;

    this.columns[cIndex].getParent().alpha = newAlpha;
  };

  public restoreColumnVisiblity = (): void => {
    for (let i = 0; i < this.columns.length; i++) {
      this.setColumnVisibilty(i, true);
    }
  };
  public getBonusLeft = (): number => {
    return this.bonusSpinsLeft;
  };

  public setBonusLeft = (val: number): void => {
    this.bonusSpinsLeft = val;
    this.display_spinsLeft.setValue(this.bonusSpinsLeft);

    let winamount = convertCreditsFromServerToClient(
      this.activeGameData.GameContext().gameRoundBalance.credits.amount
    ).toFixed(2);
    this.display_totalWin.setValue(winamount);
  };

  public getSuspense = (): SuspenseFramesBuilder => {
    return this.suspenseAnimation;
  };

  public clearExtraBonusSPinWindow = (): void => {
    this.extraBonusSpins.close();
  };
  private resetBonusCounters = (): void => {
    this.display_spinsLeft.setValue(0);
    this.display_totalWin.setValue(0);
    this.display_totalWin.setVisible(false);
    this.display_spinsLeft.setVisible(false);
  };
  public setBonusLeftVisible = (bool: boolean): void => {
    // console.log("bool", bool);
    if (this.bonusSpinsLeft >= 0) {
      this.activeGameData.BuyBonusIsClientSideReady = !bool;
      if (bool) {
        this.display_totalWin.setVisible(bool);
        this.display_spinsLeft.setVisible(bool);
      } else {
        this.resetBonusCounters();
      }
    } else {
      this.resetBonusCounters();
    }
  };

  public useBonus = (): void => {
    if (this.activeGameData.GameContext().bonusGameResult != undefined) {
      //-extra condition to substract
      if (
        this.activeGameData.GameContext().usedInputAction ==
        this.activeGameData.API_handler.getServerActionBonusSpin()
      ) {
        this.display_spinsLeft.setValue(this.bonusSpinsLeft - 1);
      }
    }
  };

  private setPortraitReelVisible = (): void => {
    let screenRatio = window.innerHeight / window.innerWidth;
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    let verticalMode = false;
    if (
      orientationPortrait &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      verticalMode = true;
    }
    if (
      this.activeGameData.isMobile &&
      this.activeGameData.playOnPortrait &&
      verticalMode
    ) {
      this.gameReelsBGPortraitMode.alpha = 1;
    } else {
      this.gameReelsBGPortraitMode.alpha = 0;
    }
  };
  public getGameReelBG = (): PIXI.Sprite => {
    return this.gameReelsBGPortraitMode;
  };

  private create = (): void => {
    this.cardSizeX = this.activeGameData.cardsize; //this.gameTilesTextures[0].width;
    this.cardSizeY = this.activeGameData.cardsize; //this.gameTilesTextures[0].height;
    // console.log(this.cardSizeX)

    //

    for (var i = 0; i < this.totalCol; i++) {
      this.columns[i] = new GameColumn(
        i,
        this.gameTilesContainer,
        this.totalRow,
        this.totalCol,
        this.activeGameData
      );
    }

    //used to animate the dices once the spin is finished
    this.dicelines[0] = [
      this.columns[0].getSprite(3),
      this.columns[1].getSprite(3),
      this.columns[2].getSprite(3),
      this.columns[3].getSprite(3),
      this.columns[4].getSprite(3),

      this.columns[0].getSprite(4),
      this.columns[1].getSprite(4),
      this.columns[2].getSprite(4),
      this.columns[3].getSprite(4),
      this.columns[4].getSprite(4),

      this.columns[0].getSprite(2),
      this.columns[1].getSprite(2),
      this.columns[2].getSprite(2),
      this.columns[3].getSprite(2),
      this.columns[4].getSprite(2),
    ];

    //null;//emptyFirstIndex contains all
    this.dicelines[1] = [
      this.columns[0].getSprite(3),
      this.columns[1].getSprite(3),
      this.columns[2].getSprite(3),
      this.columns[3].getSprite(3),
      this.columns[4].getSprite(3),
    ];
    this.dicelines[2] = [
      this.columns[0].getSprite(2),
      this.columns[1].getSprite(2),
      this.columns[2].getSprite(2),
      this.columns[3].getSprite(2),
      this.columns[4].getSprite(2),
    ];
    this.dicelines[3] = [
      this.columns[0].getSprite(4),
      this.columns[1].getSprite(4),
      this.columns[2].getSprite(4),
      this.columns[3].getSprite(4),
      this.columns[4].getSprite(4),
    ];
    this.dicelines[4] = [
      this.columns[0].getSprite(2),
      this.columns[1].getSprite(3),
      this.columns[2].getSprite(4),
      this.columns[3].getSprite(3),
      this.columns[4].getSprite(2),
    ];
    this.dicelines[5] = [
      this.columns[0].getSprite(4),
      this.columns[1].getSprite(3),
      this.columns[2].getSprite(2),
      this.columns[3].getSprite(3),
      this.columns[4].getSprite(4),
    ];

    //--

    this.dicelines[6] = [
      this.columns[0].getSprite(2),
      this.columns[1].getSprite(2),
      this.columns[2].getSprite(3),
      this.columns[3].getSprite(4),
      this.columns[4].getSprite(4),
    ];
    this.dicelines[7] = [
      this.columns[0].getSprite(4),
      this.columns[1].getSprite(4),
      this.columns[2].getSprite(3),
      this.columns[3].getSprite(2),
      this.columns[4].getSprite(2),
    ];

    this.dicelines[8] = [
      this.columns[0].getSprite(3),
      this.columns[1].getSprite(4),
      this.columns[2].getSprite(4),
      this.columns[3].getSprite(4),
      this.columns[4].getSprite(3),
    ];
    this.dicelines[9] = [
      this.columns[0].getSprite(3),
      this.columns[1].getSprite(2),
      this.columns[2].getSprite(2),
      this.columns[3].getSprite(2),
      this.columns[4].getSprite(3),
    ];

    this.dicelines[10] = [
      this.columns[0].getSprite(4),
      this.columns[1].getSprite(3),
      this.columns[2].getSprite(3),
      this.columns[3].getSprite(3),
      this.columns[4].getSprite(2),
    ];

    //---ss
    this.initialRandom();
    this.gameBoardMask = new PIXI.Graphics();
    this.gameBoardMask.beginFill(0xff0000);

    this.gameBoardMask.drawRect(
      0,
      0,
      this.cardSizeX * this.totalCol,
      this.cardSizeY * this.totalRow + 15
    );

    // this.gameBoardMask.drawRect(0, 0, this.cardSizeX * this.totalCol, this.cardSizeY * (this.totalRow) + 15);

    this.gameBoardMask.alpha = 0.01;
    if (this.activeGameData.isMobile) {
      this.gameBoardMask.y = this.cardSizeY * 2 - 7;
    } else {
      this.gameBoardMask.y = this.cardSizeY * 2 - 1;
    }
    // this.gameBoardMask.x=50
    this.gameBoardMask.endFill();
    this.gameTilesContainer.addChild(this.gameBoardMask);
    this.gameTilesContainer.mask = this.gameBoardMask;

    this.lastReelTween = this.columns[this.totalCol - 1].getEndTween(); //select the last  reel's tween to check if game  spin ended

    this.lastReelTween.on(
      "end",
      function(self: SpinGame) {
        self.SetRoundEnd();
      }.bind(this.lastReelTween, this)
    );

    // //--test mask

    // let m0 = new PIXI.Graphics();
    // m0.beginFill(0xff0ff0);
    // m0.drawRect(0, 0,50, 50);
    // m0.endFill();
    // this.activeGameData.gameScene.addChild(m0);

    // this.activeGameData.gameScene.addChild(m0);
    // let m1 = new PIXI.Graphics();
    // m1.beginFill(0xff0000);
    // m1.drawRect(0, 0, 265, 265);
    // m1.endFill();
    // m0.addChild(m1);

    // let m2 = new PIXI.Graphics();
    // m2.beginFill(0x00ff00);
    // m2.drawRect(265, 265, 900, 265);
    // m2.endFill();
    // m0.addChild(m2);
    // m0.x=290;
    // m0.y=110;
    // // m0.cacheAsBitmap=true;

    // this.activeGameData.gameScene.mask=m1;

    // // this.activeGameData.gameScene.mask=m2;

    this.bonusGameExpandAnimation = new ExpandAnimation(
      this.activeGameData.gameScene,
      this.activeGameData,
      this.gameBoardMask
    );
  };

  public createHoldToSkipBtn = (): void => {
    if (this.bonusGameExpandAnimation != undefined) {
      let partentForBtn: PIXI.Container = this.activeGameData.gameBar.getParentOfPlayBtn();
      this.holdToSkipExpandBtn = new HoldPressedCircularBtn(partentForBtn);
      this.holdToSkipExpandBtn.setPosition(0, 0);

      this.holdToSkipExpandBtn.setDuration(1);

      //-skip by holding
      if (this.activeGameData.isMobile) {
        this.holdToSkipExpandBtn.setScale(1.25);
      } else {
        this.holdToSkipExpandBtn.setScale(0.8);
      }

      //define function to excute when  hold complete
      let ExpandSkipfunction = this.bonusGameExpandAnimation.onSkipClick;
      this.holdToSkipExpandBtn.SetOnCompleteFunction(ExpandSkipfunction);
    } else {
      console.log("bonusGameExpandAnimation is not defined");
    }
  };
  public getholdToSkipExpandBtn = (): HoldPressedCircularBtn => {
    return this.holdToSkipExpandBtn;
  };
  public displayExpandSkipBtn = (bool: boolean): void => {
    this.holdToSkipExpandBtn.setVisible(bool);
  };

  // public animateExpand=():void=>
  // {
  //      //-array that need to be changed
  //   let pillarsLightToShow= getAllIndexes(this.activeGameData.GameContext().bonusGameResult.expandedReels,true)
  //   let currentBonusSymbolIndex=this.activeGameData.GameContext().expandingSymbol-1;//-1 because server daata start with 1 but locally it start wiht 0
  //   let listSymbolstoReplace=[];//make a list where to add
  //   for (let i = 0; i < pillarsLightToShow.length; i++) {
  //     //-go to the  selected columns and copy the  locations of new symbols that needs to be swapped;

  //     let offset=2;
  //     for (let j = 0+offset; j < 3+offset; j++) {
  //       let currentSymbolInTile=this.columns[pillarsLightToShow[i]].getSprite(j).getActiveIndex();
  //       // console.log(currentSymbolInTile,currentBonusSymbolIndex)
  //       if(currentSymbolInTile!=currentBonusSymbolIndex)
  //       {
  //         listSymbolstoReplace.push([pillarsLightToShow[i],j ])
  //       }

  //     }

  //     //-replace symbols

  //   }
  //   console.log(listSymbolstoReplace[0][0]);

  //   for (let i = 0; i < listSymbolstoReplace.length; i++) {
  //     let colIndex:number=listSymbolstoReplace[i][0];
  //     let rowIndex:number=listSymbolstoReplace[i][1];
  //    this.columns[colIndex].getSprite(rowIndex).setCurrentFrame(currentBonusSymbolIndex)
  //   }

  // }

  public resetReels = (): void => {
    let reel = [];
    let context = this.activeGameData.GameContext();
    // this.stopTicker();
    // this.activeGameData.infiniteSpin=false;

    console.log(
      "resetReels",
      this.activeGameData.bonusGameMode,
      this.activeGameData.bonusGameModeStarted
    );
    if (
      this.activeGameData.bonusGameMode &&
      this.activeGameData.bonusGameModeStarted
    ) {
      // console.log( "pickFrom bonus",gameContext.bonusReel1[0])
      reel[0] = [
        context.bonusGameResult.reels[0][0] - 1,
        context.bonusGameResult.reels[0][1] - 1,
        context.bonusGameResult.reels[0][2] - 1,
      ];
      reel[1] = [
        context.bonusGameResult.reels[1][0] - 1,
        context.bonusGameResult.reels[1][1] - 1,
        context.bonusGameResult.reels[1][2] - 1,
      ];
      reel[2] = [
        context.bonusGameResult.reels[2][0] - 1,
        context.bonusGameResult.reels[2][1] - 1,
        context.bonusGameResult.reels[2][2] - 1,
      ];
      reel[3] = [
        context.bonusGameResult.reels[3][0] - 1,
        context.bonusGameResult.reels[3][1] - 1,
        context.bonusGameResult.reels[3][2] - 1,
      ];
      reel[4] = [
        context.bonusGameResult.reels[4][0] - 1,
        context.bonusGameResult.reels[4][1] - 1,
        context.bonusGameResult.reels[4][2] - 1,
      ];
      // console.log( "pickFrom success bonusGmae",r1,r2,r3,r4,r5)
      // this.bonusSymbolVisible = true;
    } else {
      reel[0] = [
        context.baseGameResult.reels[0][0] - 1,
        context.baseGameResult.reels[0][1] - 1,
        context.baseGameResult.reels[0][2] - 1,
      ];
      reel[1] = [
        context.baseGameResult.reels[1][0] - 1,
        context.baseGameResult.reels[1][1] - 1,
        context.baseGameResult.reels[1][2] - 1,
      ];
      reel[2] = [
        context.baseGameResult.reels[2][0] - 1,
        context.baseGameResult.reels[2][1] - 1,
        context.baseGameResult.reels[2][2] - 1,
      ];
      reel[3] = [
        context.baseGameResult.reels[3][0] - 1,
        context.baseGameResult.reels[3][1] - 1,
        context.baseGameResult.reels[3][2] - 1,
      ];
      reel[4] = [
        context.baseGameResult.reels[4][0] - 1,
        context.baseGameResult.reels[4][1] - 1,
        context.baseGameResult.reels[4][2] - 1,
      ];
      // this.bonusSymbolVisible = false;
    }

    // console.log(reel)

    this.setFixedDices([0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0], [0, 0, 0]);

    this.setFixedDices(reel[0], reel[1], reel[2], reel[3], reel[4]);
    for (var i = 0; i < this.columns.length; i++) {
      this.columns[i].forceStop();
      // this.columns[i].checkDragonSymbol();
      // this.columns[i].textureSwap();
      // this.columns[i].reset();
      // this.columns[i].container.y = 0;
      // this.columns[i].setFlames(false)
    }
    setAllowedInputs(this.activeGameData);
  };

  public SetRoundEnd = (): void => {
    // console.log('time take per spin :',Date.now()-this.activeGameData.spinTimeCounter)

    this.gameStartTicker.stop();
    // }
    this.activeGameData.skipReelOnFlameAnimation = false;
    for (var i = 0; i < this.columns.length; i++) {
      this.columns[i].setAllDefault();
    }
    for (var j = 2; j < this.columns[0].getMaxVisibleRow() + 2; j++) {
      for (var i = 0; i < this.columns.length; i++) {
        if (j === 2) {
          // this.columns[i].tileSprite[j].setAnimationLoopActive(false);
          this.columns[i].setAnimationOnLine(j, false);
        }
      }
    }
    // extraSpinDisplay(this.activeGameData);
    // backGroundFireDisplay(this.activeGameData)
    this.activeGameData.activePlaying = false; //active game has terminated
    this.checker();
    this.checkBonusGameStart();

    this.activeGameData.lastReelSuspense = false;

    if (this.activeGameData.bonusGameMode == false) {
      // this.dragonHighlighter.setFocusAnimation(false);
    }
    this.activeGameData.balance.updateValue(
      this.activeGameData.betResponse.playerBalance.creditsBalance.amount
    ); //update the balance  but dont necessarly update  the visaul as in the end of bonus game , it will do the update on message close.
    checkUserBalToBet(this.activeGameData);

    this.displayWinlines();

    if (this.activeGameData.replayMode) {
      if (
        this.activeGameData
          .GameContext()
          .allowedInputActions.indexOf(
            this.activeGameData.API_handler.getServerActionExpandBookOfTime()
          ) >= 0
      ) {
        this.activeGameData.replay.setClickable(false);
      } else {
        this.activeGameData.replay.setClickable(true);
      }

      if (
        (this.activeGameData.bonusGameModeStarted &&
          this.activeGameData.GameContext().gameRoundBalance.bonusSpins > 0) ||
        this.activeGameData.GameContext().bonus == false
      ) {
        let whenExpandWildAllowed =
          this.activeGameData
            .GameContext()
            .allowedInputActions.indexOf(
              this.activeGameData.API_handler.getServerActionExpandBookOfTime()
            ) >= 0;
        if (whenExpandWildAllowed == false) {
          // console.log("pick");
          // console.log("increment22");
          this.activeGameData.replay.incrementIndex();
        }
      }
    }

    //--
    this.checkExpandedWin();
    // console.log('UPDATE WIN', this.isExpandBonusActive)
    updateWin(this.activeGameData);

    if (this.activeGameData.GameContext().bonusGameResult == undefined) {
      //update emulation balance if game round is ended
      updateEmulationWinBalance(this.activeGameData);
    }
    enableEmulationInterfaceOnFeatureSelect(this.activeGameData, true);
  };

  private checkBonusGameStart = (): void => {
    if (
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.bonusGameModeStarted === false
    ) {
      //at the begining of bonus game
      //-reload game display message in
      this.activeGameData.playable = false;
      this.activeGameData.gameBar.setBlackAndWhitePlay();
      let bonusMessageText = this.activeGameData.bonusGameInfos.getMessageBox();

      if (this.activeGameData.replayMode == true) {
        // setTimeout(() => {
        bonusMessageText.displayMessageIn();
        if (this.activeGameData.sound_bellRing.playing) {
          this.activeGameData.sound_bellRing.stop();
        }
        this.activeGameData.sound_bellRing.play("sound");
        // }, 0);
      } else {
        // time to wait on base game
        let totalWinlines = this.activeGameData.GameContext().baseGameResult
          .winCombinations.length;
        if (this.activeGameData.GameContext().bonusGameResult != undefined) {
          totalWinlines = this.activeGameData.GameContext().bonusGameResult
            .winCombinations.length;
          this.activeGameData.gameBar.setBlackAndWhitePlay();
        }

        //check the

        // console.log(this.activeGameData.newWinAnimation.isBigWin(this.activeGameData.GameContext().win.credits.amount,this.activeGameData.betSelected.value));

        let isBigWin = this.activeGameData.newWinAnimation.isBigWin(
          this.activeGameData.GameContext().win.credits.amount,
          this.activeGameData.betSelected.value
        );

        let winSpin = this.activeGameData.GameContext().win.credits.amount;
        if (this.activeGameData.GameContext().finished) {
          winSpin = this.activeGameData.GameContext().gameRoundBalance.credits
            .amount;
        }

        if (isBigWin == false) {
          let waitPerWinline = 0;
          let endWaitTime = totalWinlines * waitPerWinline;
          setTimeout(() => {
            bonusMessageText.displayMessageIn();

            this.activeGameData.sound_bellRing.stop();
            this.activeGameData.sound_bellRing.play("sound");
            this.activeGameData.gameBar.setBlackAndWhitePlay();
          }, endWaitTime);
        } else {
          this.activeGameData.newWinAnimation.displayWin(
            winSpin,
            this.activeGameData.betSelected.value
          );
        }
        // console.log("isBigWin", isBigWin)
      }

      this.setBonusLeftVisible(true);
    } else {
      // other wise toggele to bonus mode
      toggleBonusGameMode(this.activeGameData);
    }
  };
  private checkExpandedWin = (): void => {
    ///--- Bonus Game Expand Check

    if (
      this.activeGameData
        .GameContext()
        .allowedInputActions.indexOf(
          this.activeGameData.API_handler.getServerActionExpandBookOfTime()
        ) >= 0 &&
      this.activeGameData.expandRequested == false
    ) {
      // console.log(
      //   "ANIM expand",
      //   this.activeGameData.GameContext().bonusGameResult.winCombinations.length
      // );

      disableAllBtns(this.activeGameData);

      this.setexpandAllowed(true);
      if (
        this.activeGameData.GameContext().bonusGameResult != undefined &&
        this.activeGameData.GameContext().bonusGameResult.winCombinations
          .length == 0
      ) {
        //-no winlines so will do expand  directly , if winlines are present , the checkSymbolToExpand is called at the end of winlines cycle
        checkSymbolToExpand(this.activeGameData);

        // console.log(
        //   "---------No WIN---------------",
        //   this.activeGameData.expandRequested
        // );
      }
    } else {
      if (this.activeGameData.replayMode == false) {
        resetAllBtns(this.activeGameData);
        this.activeGameData.gameBar.setBlackAndWhitePlay();
      }

      this.activeGameData.setAllowedInputs(this.activeGameData);
    }
  };
  public getexpandAllowed = (): boolean => {
    return this.expandAllowed;
  };
  public setexpandAllowed = (bool: boolean): void => {
    this.expandAllowed = bool;
  };
  private checker = (): void => {
    for (var i = 0; i < 5; i++) {
      for (var j = 2; j < 5; j++) {
        let servervalue = this.reel[i][j - 2];
        let reelvalue = this.columns[i].getValueAtLine(j); // tileSprite[j].getActiveIndex(); //display value
        if (servervalue != reelvalue) {
          console.log("-----Game Display NS------"); //+ i,j-2);//for  display issue patches
          this.setFixedDices(
            this.reel[0],
            this.reel[1],
            this.reel[2],
            this.reel[3],
            this.reel[4]
          );
        }
      }
      // console.log( this.reel[i],servervalue[i]);
    }
  };
  private setgameTicker = (): void => {
    this.gameStartTicker.stop();
    this.gameStartTicker.add((delta) => {
      this.deltaTime =
        delta / PIXI.settings.TARGET_FPMS / this.gameStartTicker.speed;

      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].getEaseInClear() === false) {
          this.columns[i].setSpeed(this.deltaTime);
        } else {
          this.columns[i].setTweenIn();
        }
      }
    });
  };
  // public setOutFrameBonusGameRandom = (): void => {
  //   for (let i = 0; i < 5; i++) {
  //     this.columns[i].setRandomOutFrame();
  //   }
  // };
  public startTicker = (): void => {
    //
    resetExtraSpin(this.activeGameData);
    this.gameStartTicker.start();
  };

  // private resetDelayLastReel = (): void => {
  //   this.columns[4].resetDelayLastReel(); //recover flammes around dragon
  // };

  public stopTicker = (): void => {
    this.gameStartTicker.stop();
  };
  public setGameStop = (gameContext: TalesOfTimeGameContext): void => {
    //--check
    this.checkSymbolTime();

    ///---------FixIT<
    // console.log("Set game fixed Dice")

    // this.resetDelayLastReel();
    // this.dragonHighlighter.setExtraSpinAnimation(false);
    let r1 = [];
    let r2 = [];
    let r3 = [];
    let r4 = [];
    let r5 = [];
    // if(this.activeGameData.bonusGameMode)
    // if(((this.activeGameData.betResponse.gameContext).stake.credits))
    // console.log(this.activeGameData.betResponse)

    let context = this.activeGameData.GameContext();
    // console.log("SET 1",    !isNullOrUndefined(gameContext.bonusGameResult), gameContext.bonus)
    if (
      !isNullOrUndefined(gameContext.bonusGameResult) &&
      this.activeGameData.bonusGameMode
    ) {
      this.activeGameData.bonusGameModeStarted = true;
    } else {
      this.activeGameData.bonusGameModeStarted = false;
    }

    if (
      this.activeGameData.reloadGame &&
      context.gameRoundBalance.bonusSpins == 0 &&
      context.finished
    ) {
      this.activeGameData.bonusGameModeStarted = false;
    }

    if (
      this.activeGameData.bonusGameMode &&
      this.activeGameData.bonusGameModeStarted
    ) {
      // console.log( "pickFrom bonus",context.bonusGameResult[0])
      r1 = [
        gameContext.bonusGameResult.reels[0][0] - 1,
        gameContext.bonusGameResult.reels[0][1] - 1,
        gameContext.bonusGameResult.reels[0][2] - 1,
      ];
      r2 = [
        gameContext.bonusGameResult.reels[1][0] - 1,
        gameContext.bonusGameResult.reels[1][1] - 1,
        gameContext.bonusGameResult.reels[1][2] - 1,
      ];
      r3 = [
        gameContext.bonusGameResult.reels[2][0] - 1,
        gameContext.bonusGameResult.reels[2][1] - 1,
        gameContext.bonusGameResult.reels[2][2] - 1,
      ];
      r4 = [
        gameContext.bonusGameResult.reels[3][0] - 1,
        gameContext.bonusGameResult.reels[3][1] - 1,
        gameContext.bonusGameResult.reels[3][2] - 1,
      ];
      r5 = [
        gameContext.bonusGameResult.reels[4][0] - 1,
        gameContext.bonusGameResult.reels[4][1] - 1,
        gameContext.bonusGameResult.reels[4][2] - 1,
      ];
      // console.log("pickFrom bonus");
      // this.bonusSymbolVisible = true;
    } else {
      r1 = [
        gameContext.baseGameResult.reels[0][0] - 1,
        gameContext.baseGameResult.reels[0][1] - 1,
        gameContext.baseGameResult.reels[0][2] - 1,
      ];
      r2 = [
        gameContext.baseGameResult.reels[1][0] - 1,
        gameContext.baseGameResult.reels[1][1] - 1,
        gameContext.baseGameResult.reels[1][2] - 1,
      ];
      r3 = [
        gameContext.baseGameResult.reels[2][0] - 1,
        gameContext.baseGameResult.reels[2][1] - 1,
        gameContext.baseGameResult.reels[2][2] - 1,
      ];
      r4 = [
        gameContext.baseGameResult.reels[3][0] - 1,
        gameContext.baseGameResult.reels[3][1] - 1,
        gameContext.baseGameResult.reels[3][2] - 1,
      ];
      r5 = [
        gameContext.baseGameResult.reels[4][0] - 1,
        gameContext.baseGameResult.reels[4][1] - 1,
        gameContext.baseGameResult.reels[4][2] - 1,
      ];
      // this.bonusSymbolVisible = false;
    }

    this.reel = [r1, r2, r3, r4, r5];

    // console.log(r1,r2,r3,r4)
    this.columns[0].setEndArray(r1);
    this.columns[1].setEndArray(r2);
    this.columns[2].setEndArray(r3);
    this.columns[3].setEndArray(r4);
    this.columns[4].setEndArray(r5);

    // console.log(this.columns);

    let winlineComb = GetWinlineCombo(this.activeGameData);

    this.winlineToDisplay = [];

    if (isNullOrUndefined(winlineComb) == false) {
      //--filter
      this.activeGameData.scatterList = [];
      this.activeGameData.winlinnesList = [];
      this.activeGameData.collectableList = [];

      //--clear

      for (let i = 0; i < winlineComb.length; i++) {
        if (winlineComb[i].combinationType === "LINE") {
          this.activeGameData.winlinnesList.push(winlineComb[i]);
        }
        if (winlineComb[i].combinationType === "SCATTER") {
          this.activeGameData.scatterList.push(winlineComb[i]);
        }
        if (winlineComb[i].combinationType === "COLLECTIBLE") {
          this.activeGameData.collectableList.push(winlineComb[i]);
        }
      }
      // console.log("=====>",this.activeGameData.winlinnesList)

      for (let i = 0; i < this.activeGameData.winlinnesList.length; i++) {
        // const element = array[i];
        let winline = this.activeGameData.winlinnesList[i].lineNumber;
        let count = this.activeGameData.winlinnesList[i].count;
        // let result=[winline,count];

        if (this.winlineToDisplay[i] == undefined) {
          this.winlineToDisplay[i] = [];
        }
        this.winlineToDisplay[i].push(winline, count);

        // console.log(this.winlineToDisplay)
      }
    }

    // this.currentWin = gameContext.win;

    if (this.activeGameData.reloadGame) {
      if (
        this.activeGameData.GameContext().usedInputAction ==
        this.activeGameData.API_handler.getServerActionExpandBookOfTime()
      ) {
        // if expanded
        this.expandedWinlinesActive = true;
      } else {
        this.expandedWinlinesActive = false;
      }
      this.reloadGame(r1, r2, r3, r4, r5);
      this.setWinlineHidden();
      //---REPLAY FUNCTION AVOID THIS WHEN PLAYING IN THE SPIN INSTEAD OF RECOVERY
      if (
        this.activeGameData.replayMode &&
        this.activeGameData.useSpinOnReplayInsteadOfRecovery
      ) {
        // this.displayWinlines();//skip it
      } else {
        this.displayWinlines();
      }

      ///-display  message for replay and bonus game :.
      if (this.activeGameData.displayReplayMsg) {
        //new

        let bonusMessageText = this.activeGameData.bonusGameInfos
          .getMessageBox()
          .getReloadMessageBox();
        // bonusMessageText.getDisplayMessageIn();
        let openBox = bonusMessageText.getDisplayMessageIn();
        openBox();

        if (
          this.activeGameData.GameContext().bonusGameResult != undefined &&
          this.activeGameData.GameContext().finished == false
        ) {
          //-recover  the  win info only if its bonus game
          this.setBonusLeftVisible(true);
        }

        // bonusMessageText.setRecoveryText();
        if (this.activeGameData.replay.isOpen()) {
          let message = this.activeGameData.replay.getMessageToDisplay();
          bonusMessageText.setNewText("", message);
          // console.log('DISPLAY BACK TO GAME' )
        } else {
          bonusMessageText.setNewText(
            "",
            this.activeGameData.gameTextGeneral.gameRecovered
          );
        }
      } else {
        //reload the message box
        if (
          this.activeGameData.GameContext().bonus &&
          this.activeGameData.GameContext().usedInputAction ===
            this.activeGameData.API_handler.getServerActionBet()
        ) {
          if (
            this.activeGameData.replayMode &&
            this.activeGameData.useSpinOnReplayInsteadOfRecovery
          ) {
            //avoid showing the  bonus win message popup
            return;
          }
          //-reload game display message in
          this.activeGameData.bonusGameInfos.getMessageBox().displayMessageIn();
          this.activeGameData.gameBar.setBlackAndWhitePlay();
          this.activeGameData.playable = false;
        }
      }

      if (this.activeGameData.bonusGameModeStarted) {
        if (
          this.activeGameData.GameContext().bonus &&
          this.activeGameData.GameContext().usedInputAction === "BET"
        ) {
          replaceAllWithBonus(this.activeGameData, true);
        }
      }

      // if (this.activeGameData.GameContext().gameRoundBalance.bonusSpins > 0 && this.activeGameData.GameContext().usedInputAction === "BONUSSPIN") { toggleBonusGameMode(this.activeGameData) }

      toggleBonusGameMode(this.activeGameData);
      // this.setLastReelFire(false);
    }
  };

  public checkMessageToDisplay = (): void => {
    if (this.activeGameData.replayMode == false) {
      this.checkBonusGameMessageIn();
      this.checkBonusGameMessageOut();
    }
  };

  private checkBonusGameMessageIn = (): void => {
    if (
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.GameContext().usedInputAction ===
        this.activeGameData.API_handler.getServerActionBet()
    ) {
      //-reload game display message in
      this.activeGameData.bonusGameInfos.getMessageBox().displayMessageIn();
      this.activeGameData.gameBar.setBlackAndWhitePlay();
      this.activeGameData.playable = false;
    }
  };

  private checkBonusGameMessageOut = (): void => {
    if (
      this.activeGameData.GameContext().bonusGameResult != undefined &&
      //--
      this.activeGameData.GameContext().bonus == false &&
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins === 0 &&
      this.activeGameData.GameContext().finished
    ) {
      //-reload game display message in
      this.activeGameData.bonusGameInfos.getMessageBox().displayMessageOut();
      this.activeGameData.gameBar.setBlackAndWhitePlay();
      this.activeGameData.playable = false;
    }
  };

  private initialRandom = (): void => {
    let r1 = [
      Math.floor(Math.random() * 3),
      Math.floor(Math.random() * 3),
      Math.floor(Math.random() * 3),
    ];
    let r2 = [
      Math.floor(Math.random() * 3 + 3),
      Math.floor(Math.random() * 3 + 3),
      Math.floor(Math.random() * 3 + 3),
    ];
    let r3 = [
      Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 6),
    ];
    let r4 = [
      Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 6),
    ];
    let r5 = [
      Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 6),
    ];

    // r2=r3=r4=r5=r1=[7,7,7];
    let reelsGenerated = [r1, r2, r3, r4, r5];
    let gameCtx = this.activeGameData.GameContext();
    let gameReels = [
      gameCtx.baseGameResult.reels[0],
      gameCtx.baseGameResult.reels[1],
      gameCtx.baseGameResult.reels[2],
      gameCtx.baseGameResult.reels[3],
      gameCtx.baseGameResult.reels[4],
    ];

    for (let j = 0; j < reelsGenerated.length; j++) {
      for (let i = 0; i < r1.length; i++) {
        gameReels[j][i] = reelsGenerated[j][i] + 1;
      }
    }

    this.columns[0].setFixedDicesPerCol(r1);
    this.columns[1].setFixedDicesPerCol(r2);
    this.columns[2].setFixedDicesPerCol(r3);
    this.columns[3].setFixedDicesPerCol(r4);
    this.columns[4].setFixedDicesPerCol(r5);
  };

  private reloadGame = (
    r1: Array<number>,
    r2: Array<number>,
    r3: Array<number>,
    r4: Array<number>,
    r5: Array<number>
  ): void => {
    //Set the upcoming reels with random bonus symbol
    for (var i = 0; i < this.columns.length; i++) {
      this.columns[i].setAllDefault();
    }
    if (this.activeGameData.bonusGameMode) {
      // this.setOutFrameBonusGameRandom();
    }

    //Set the reels from active game
    this.setFixedDices(r1, r2, r3, r4, r5);
    this.activeGameData.lastReelSuspense = false;

    this.displayWinlines();

    this.activeGameData.reloadGame = false; // set recover to false once everything is srestored
    let gamblefinished = this.activeGameData.GameContext().finished;
    if (
      this.activeGameData.GameContext().usedInputAction === "GAMBLE" &&
      gamblefinished == false
    ) {
      gambleClick(this.activeGameData);
    }
    this.activeGameData.API_handler.getServerActionExpandBookOfTime();
    // console.log("reload",this.activeGameData.GameContext().allowedInputActions)
    checkSymbolToExpand(this.activeGameData);

    if (
      this.activeGameData.GameContext().bonusGameResult != undefined &&
      this.activeGameData.GameContext().finished == false
    ) {
      this.setBonusLeft(
        this.activeGameData.GameContext().gameRoundBalance.bonusSpins
      );
    }
  };

  public setFixedDices = (
    r1: Array<number>,
    r2: Array<number>,
    r3: Array<number>,
    r4: Array<number>,
    r5: Array<number>
  ): void => {
    this.columns[0].setFixedDicesPerCol(r1);
    this.columns[1].setFixedDicesPerCol(r2);
    this.columns[2].setFixedDicesPerCol(r3);
    this.columns[3].setFixedDicesPerCol(r4);
    this.columns[4].setFixedDicesPerCol(r5);

    this.columns[0].setEndArray(r1);
    this.columns[1].setEndArray(r2);
    this.columns[2].setEndArray(r3);
    this.columns[3].setEndArray(r4);
    this.columns[4].setEndArray(r5);
  };

  public changeBonusSymbolTint = (bool: boolean): void => {
    // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++")
    if (bool) {
      //-get scatter
      // console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++")

      let winlineComb = GetWinlineCombo(this.activeGameData);
      this.winlineToDisplay = [];
      if (isNullOrUndefined(winlineComb) == false) {
        this.activeGameData.scatterList = [];

        for (let i = 0; i < winlineComb.length; i++) {
          if (winlineComb[i].combinationType === "SCATTER") {
            this.activeGameData.scatterList.push(winlineComb[i]);
          }
        }

        if (
          this.activeGameData.scatterList != undefined &&
          this.activeGameData.scatterList.length >= 1
        ) {
          let shPos = this.activeGameData.scatterList[0].scatterPositions;
          // console.log(this.activeGameData.scatterList); //--good
          for (let i = 0; i < shPos.length; i++) {
            let posX = shPos[i].x;
            let posY = shPos[i].y + 2; // offset +2 bc the  symbols reels has 2 invisible row on top for spins

            this.columns[posX].getSprite(posY).setUsedGiftBoxTint(true);
          }
          this.bonusUsed = true;
        }
      }
    } else if (this.bonusUsed == true) {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].getSprite(0).setUsedGiftBoxTint(false);
        this.columns[i].getSprite(1).setUsedGiftBoxTint(false);
        this.columns[i].getSprite(2).setUsedGiftBoxTint(false);
        this.columns[i].getSprite(3).setUsedGiftBoxTint(false);
        this.columns[i].getSprite(4).setUsedGiftBoxTint(false);
      }
      this.bonusUsed = false;
    }
  };

  private animateDiceOnWin = (): void => {
    if (this.expandedWinlinesActive) {
      //bonus game expanded
      let expandedAllWinlines = getAllIndexes(
        this.activeGameData.GameContext().bonusGameResult.expandedReels,
        true
      );

      for (let index = 0; index < this.winlineToDisplay.length; index++) {
        let winLineAndlength = this.winlineToDisplay[index];
        // console.log(this.winlineToDisplay)//--return ex:[2,3]

        for (let i = 0; i < winLineAndlength[1]; i++) {
          // let offsetlocation=expandedAllWinlines[i];

          this.dicelines[winLineAndlength[0]][
            expandedAllWinlines[i]
          ].setLoopAndPlay();
          this.dicelines[winLineAndlength[0]][
            expandedAllWinlines[i]
          ].setBlackenTint(false);
        }
      }
    } else {
      //default
      for (let index = 0; index < this.winlineToDisplay.length; index++) {
        let winLineAndlength = this.winlineToDisplay[index];
        // console.log(this.winlineToDisplay)//--return ex:[2,3]

        for (let i = 0; i < winLineAndlength[1]; i++) {
          this.dicelines[winLineAndlength[0]][i].setLoopAndPlay();
          this.dicelines[winLineAndlength[0]][i].setBlackenTint(false);
        }
      }
    }

    if (
      this.activeGameData.scatterList != undefined &&
      this.activeGameData.scatterList.length >= 1
    ) {
      let shPos = this.activeGameData.scatterList[0].scatterPositions;
      for (let i = 0; i < shPos.length; i++) {
        // console.log(shPos[i].x, shPos[i].y + 2); // offset +2 bc the  symbols reels has 2 invisible row on top for spins
        let posX = shPos[i].x;
        let posY = shPos[i].y + 2; // offset +2 bc the  symbols reels has 2 invisible row on top for spins

        this.columns[posX].getSprite(posY).setLoopAndPlay();
        this.columns[posX].getSprite(posY).setBlackenTint(false);
      }
      if (this.activeGameData.giftBoxWin.playing) {
        this.activeGameData.giftBoxWin.stop();
      }
      this.activeGameData.giftBoxWin.play("bonus");
      this.extraBonusSpins.displayMessage();
    }
  };

  public checkExpandOnExtraSpinWinButNoWinlines = (): void => {
    if (this.activeGameData.GameContext().bonusGameResult != undefined) {
      if (
        this.activeGameData
          .GameContext()
          .allowedInputActions.indexOf(
            this.activeGameData.API_handler.getServerActionExpandBookOfTime()
          ) >= 0
      ) {
        if (
          this.activeGameData.GameContext().bonusGameResult.winCombinations
            .length == 1
        ) {
          if (
            this.activeGameData.GameContext().bonusGameResult.winCombinations[0]
              .combinationType == "SCATTER"
          ) {
            // console.log("SPECIAL CASE EXPAND");
            //  expandSymbolRequest(this.activeGameData);
            checkSymbolToExpand(this.activeGameData);
          }
        }
      }
    }
  };

  public getExpandedWinlinesActive = (): boolean => {
    return this.expandedWinlinesActive;
  };

  public setExpandedWinlinesActive = (bool: boolean) => {
    this.expandedWinlinesActive = bool;
  };
  private displayWinlines = (): void => {
    //--grayout everything
    let getContextWinCombo = GetWinlineCombo(this.activeGameData);

    if (getContextWinCombo.length > 0) {
      this.setFocused(true);
    } else {
      this.setFocused(false);
    }

    //hightlight winnings
    let startHightlight = false;
    let userAction = this.activeGameData.GameContext().usedInputAction;
    let actionBet = this.activeGameData.API_handler.getServerActionBet();
    let actionRespin = this.activeGameData.API_handler.getServerActionBonusSpin();
    let actionExpand = this.activeGameData.API_handler.getServerActionExpandBookOfTime();

    //--fix for display winlines
    if (this.activeGameData.GameContext().bonus) {
      // if (this.activeGameData.GameContext().bonusSpinWin.credits.amount > 0) {
      startHightlight = true;
      // }
    } else if (
      userAction == actionBet ||
      userAction == actionRespin ||
      userAction == actionExpand
    ) {
      if (this.activeGameData.GameContext().win.credits.amount > 0) {
        startHightlight = true;
      }
    }

    if (startHightlight) {
      // console.log("DISPLAY WINLINES")
      this.winlines.setWinFrameStyle(0);
      this.winlines.setWinlineToDisplay();
      this.animateDiceOnWin(); //-animate dice
    }
  };

  public setFocused = (bool: boolean): void => {
    // console.log(bool,"---grayAll")
    for (let i = 0; i < this.dicelines[0].length; i++) {
      this.dicelines[0][i].setBlackenTint(bool);
    }
  };

  private placeTo = (parent: PIXI.Container): void => {
    //placebtn

    let posX = this.activeGameData.size[0] / 2;
    let posY = this.activeGameData.size[1] / 2;

    this.parentContainer.addChild(this.extraSpinFXContainer);
    this.parentContainer.addChild(this.gameTilesContainer);
    this.parentContainer.addChild(this.decoContainer);

    parent.addChild(this.parentContainer);
    this.parentContainer.x = posX - this.parentContainer.width / 2;
    // this.parentContainer.y=posY-this.parentContainer.height/2-250;//posY-this.parentContainer.height/2+50;
    this.parentContainer.y =
      posY - this.parentContainer.height / 2 - this.cardSizeY - 69; //posY-this.parentContainer.height/2+50;
    if (this.activeGameData.isMobile) {
      this.parentContainer.y =
        posY - this.parentContainer.height / 2 - this.cardSizeY - 70;
    }
    // this.gameBoardMask.y=this.parentContainer.height-this.gameBoardMask.height;

    this.parentContainerWrapper.beginFill(0xff0000);
    this.parentContainerWrapper.drawRect(
      0,
      0,
      this.parentContainer.width,
      this.parentContainer.height
    );
    this.parentContainerWrapper.endFill();
    this.parentContainerWrapper.position.set(0);
    this.parentContainerWrapper.alpha = 0.5;
    // this.parentContainer.addChild( this.parentContainerWrapper);
    this.gameTilesContainer.x =
      this.parentContainer.width / 2 - this.gameTilesContainer.width / 2;
    this.gameTilesContainer.y =
      this.parentContainer.height / 2 - this.gameTilesContainer.height / 2 + 50;

    //   this.gameTilesContainer.x =0
    // this.gameTilesContainer.y =-210;

    this.winlines = new WinLineBuilder(parent, this.activeGameData);

    this.parentContainer.addChild(this.dragonHighlighterContainer);
  };
  public setMainGameContainerAlpha = (num: number): void => {
    this.parentContainer.alpha = num;
  };
  public getIsGameStarted = (): boolean => {
    return this.gameStartTicker.started;
  };
  public getColumn = (index: number): GameColumn => {
    return this.columns[index];
  };

  public getAllColumns = (): Array<GameColumn> => {
    return this.columns;
  };
  public getTotalColumns = (): number => {
    return this.columns.length;
  };
  public setWinlineHidden = (): void => {
    this.winlines.sethidden();
    this.disableAllSymbolsAnimation();
  };

  public getWinliesSwapSpeed = (): number => {
    return this.winlines.getSwitchSpeed();
  };

  public getWinlinesBuilder = (): WinLineBuilder => {
    return this.winlines;
  };
  public disableAllSymbolsAnimation = (): void => {
    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].disableAnimation();
    }
    this.setFocused(false);
  };

  public expandSuccess = (): void => {
    let pillarsLightToShow = getAllIndexes(
      this.activeGameData.GameContext().bonusGameResult.expandedReels,
      true
    );
    // console.log("expandSucc",pillarsLightToShow);

    this.bonusGameExpandAnimation.showPillar(pillarsLightToShow);
    //--
  };

  public winlineExpanded = (): void => {
    betSuccessCallBack(this.activeGameData.betResponse, this.activeGameData);
    this.setGameStop(this.activeGameData.GameContext());
    // this.expandedWinlinesActive=true;
    this.setExpandedWinlinesActive(true);
    this.SetRoundEnd(); ///-swap the  symbols
  };

  public resetGameForTournament = (): void => {
    //reset everything to fresh game

    //overwrite bonus contexts
    this.activeGameData.GameContext().bonus = false;
    this.activeGameData.GameContext().bonusGameResult = undefined;
    this.activeGameData.GameContext().gameRoundBalance.bonusSpins = 0;
    this.activeGameData.GameContext().finished = true;

    //clear wins
    this.activeGameData.GameContext().win.bonusSpins = 0;
    this.activeGameData.GameContext().win.credits.amount = 0;
    this.activeGameData.GameContext().gameRoundBalance.credits.amount = 0;
    this.activeGameData.GameContext().gameRoundBalance.bonusSpins = 0;
    this.activeGameData.winValue.updateValue(0);
    updateWinBar(false, this.activeGameData);
    this.initialRandom();

    clearOnReplayOpenClose(this.activeGameData);
    if (this.activeGameData.bonusGameInfos.getIsVisibile()) {
      this.activeGameData.bonusGameInfos.setVisible(false);
    }
  };
}
